/**
 * Extracts initials from an agency name.
 * If the name has 2+ words, returns the first letter of each word.
 * Otherwise, returns the first 2 characters.
 */
export const getAgencyInitials = (name: string): string => {
  const wordList = name.split(' ')
  if (wordList.length >= 2) {
    return `${wordList[0][0]}${wordList[1][0]}`.toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

/**
 * Formats a usage count number into a human-readable string.
 * Examples: 1500 -> "1.5K", 2500000 -> "2.5M"
 */
export const formatUsageCount = (count: number): string => {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1)}M`
  }
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}K`
  }
  return count.toString()
}
